import React from "react";

const isFileDrag = (event: React.DragEvent) => Array.from(event.dataTransfer.types).includes("Files");

type Options = {
    onFiles: (files: File[]) => void;
    disabled?: boolean;
    onDisabledDrop?: () => void;
};

export const useFileDropHandlers = <T extends HTMLElement>({ onFiles, disabled, onDisabledDrop }: Options) => {
    const dragCounterRef = React.useRef(0);
    const [isDragging, setIsDragging] = React.useState(false);

    const onDragEnter = (event: React.DragEvent<T>) => {
        if (!isFileDrag(event)) {
            return;
        }

        event.preventDefault();
        dragCounterRef.current += 1;
        if (!disabled) {
            setIsDragging(true);
        }
    };

    const onDragOver = (event: React.DragEvent<T>) => {
        event.preventDefault();
    };

    const onDragLeave = (event: React.DragEvent<T>) => {
        if (!isFileDrag(event)) {
            return;
        }

        dragCounterRef.current = Math.max(0, dragCounterRef.current - 1);
        if (dragCounterRef.current === 0) {
            setIsDragging(false);
        }
    };

    const onDrop = (event: React.DragEvent<T>) => {
        event.preventDefault();
        dragCounterRef.current = 0;
        setIsDragging(false);

        if (!isFileDrag(event)) {
            return;
        }

        if (disabled) {
            onDisabledDrop?.();
            return;
        }

        onFiles(Array.from(event.dataTransfer.files));
    };

    return { isDragging, onDragEnter, onDragOver, onDragLeave, onDrop };
};
